<div class="modal-header">
  <h5 class="modal-title">
    {{ data.label }}
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <i class="fal fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <h5 class="primary-item" *ngIf="data.type === 'email'">
          Primary {{ data.itemLabel }}: <strong>{{ data.primaryItem() }}</strong>
        </h5>
        <h5 class="primary-item" *ngIf="data.type === 'phone'">
          Primary {{ data.itemLabel }}: <strong>{{ data.primaryItem() }}</strong>
        </h5>
      </div>

      <div *ngFor="let item of data.items(); let i = index" class="col-sm-12">
        <div class="row" *ngIf="item != data.primaryItem() && item !== ''">
          <div class="col-md-1">
            <button (click)="removeOldItem(i)" class="remove-item-button add-remove-item-btn" type="button">
              <i class="fal fa-minus"></i>
            </button>
          </div>
          <div class="col-md-8">
            <mat-form-field class="mat-block">
              <input type="text" matInput value="{{ item }}" placeholder="{{ data.itemLabel }}" readonly />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <button
              (click)="makePrimaryOldItem(i)"
              [matTooltip]="data.makePrimaryLabel"
              matTooltipPosition="above"
              matTooltipClass="text-center"
              type="button"
              class="btn btn-outline-warning make-primary-btn"
            >
              Primary
            </button>
          </div>
        </div>
      </div>

      <div
        formArrayName="newItems"
        *ngFor="let item of newItems.controls; let i = index; let last = last"
        class="col-sm-12"
      >
        <div class="row" [formGroupName]="i">
          <div class="col-md-1">
            <button *ngIf="last" (click)="addNewItem(i)" class="add-item-button add-remove-item-btn" type="button">
              <i class="fal fa-plus"></i>
            </button>
            <button
              *ngIf="!last"
              (click)="removeNewItem(i)"
              class="remove-item-button add-remove-item-btn"
              type="button"
            >
              <i class="fal fa-minus"></i>
            </button>
          </div>
          <div class="col-md-8">
            <mat-form-field class="mat-block">
              <input
                type="text"
                formControlName="formItem"
                matInput
                [placeholder]="last ? data.newItemLabel : data.itemLabel"
              />
              <mat-error *ngIf="item.get('formItem').touched && item.get('formItem').hasError('email')">
                Email must have valid format
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3 button-box">
            <button
              *ngIf="item.get('formItem').invalid || !item.get('formItem').value"
              matTooltip="Enter valid value"
              matTooltipPosition="above"
              matTooltipClass="text-center"
              type="button"
              class="btn btn-outline-warning make-primary-btn"
            >
              Primary
            </button>
            <button
              *ngIf="!item.get('formItem').invalid && item.get('formItem').value"
              [matTooltip]="data.makePrimaryLabel"
              matTooltipPosition="above"
              matTooltipClass="text-center"
              (click)="makePrimaryNewItem(i)"
              type="button"
              class="btn btn-outline-warning make-primary-btn"
            >
              Primary
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="save(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> save
  </button>
</div>
